import { useEffect, useState } from 'react'
import { Form, Input, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import styles from './adduserteacher.module.scss'
import { TEACHER } from '@BUP/constants'
import AlertComponent from '@BUP/components/Generics/Alert'
import ButtonComponent from '@BUP/components/Generics/Buttons/button-component'

// TODO: add validations
const AddUserTeacherForm = ({
  createEnrollment,
  courses,
  loading,
  error,
  setCourseId,
  isMulticourse
}) => {
  const [, forceUpdate] = useState()
  const [t] = useTranslation()
  const [form] = Form.useForm()
  const { Option } = Select

  const [formValues, setFormValues] = useState({
    name: null,
    email: null,
    courseId: null,
    roleType: TEACHER,
    password: null,
    mainTeacher: false
  })

  const handleChangeInputName = e => {
    setFormValues({ ...formValues, name: e.target.value })
  }

  const handleChangeInputEmail = e => {
    setFormValues({ ...formValues, email: e.target.value })
  }

  const handleChangeInputPassword = e => {
    setFormValues({ ...formValues, password: e.target.value })
  }

  const handleSelectCourse = courseId => {
    setCourseId(courseId)
  }

  const isSubmitDisabled =
    !formValues.name?.trim() ||
    !formValues.email?.trim() ||
    !formValues.password?.trim()

  const onSubmit = async () => {
    if (isSubmitDisabled) return
    form.resetFields()
    await createEnrollment(formValues)
  }

  useEffect(() => {
    forceUpdate()
  }, [])

  return (
    <Form
      onFinish={onSubmit}
      form={form}
      layout='horizontal'
      labelCol={{
        span: 10
      }}
      className={styles.form_wrapper}
      wrapperCol={{
        span: 24
      }}
    >
      <Form.Item
        label={t('common.resources.user.attributes.name.label')}
        layout='horizontal'
        onChange={handleChangeInputName}
      >
        <Input
          placeholder={t('common.resources.user.attributes.name.placeholder')}
          name='name'
        />
      </Form.Item>
      <Form.Item
        label={t('common.resources.user.attributes.email.label')}
        layout='horizontal'
        onChange={handleChangeInputEmail}
      >
        <Input
          placeholder={t('common.resources.user.attributes.email.placeholder')}
          name='email'
        />
      </Form.Item>
      <Form.Item
        label={t('common.resources.user.attributes.password.label')}
        layout='horizontal'
        onChange={handleChangeInputPassword}
      >
        <Input.Password
          placeholder={t('common.resources.user.attributes.password.placeholder')}
          name='name'
        />
      </Form.Item>
      {!isMulticourse && (
        <Form.Item label={t('common.resources.course.label')}>
          <Select onChange={handleSelectCourse}>
            {courses && courses.length
              ? courses.map(course => (
                <Option
                  key={`course-${course?.id}`}
                  value={course?.id}
                >
                  {course.name}
                </Option>
              ))
              : null}
          </Select>
        </Form.Item>
      )}
      <Form.Item>
        <div className={styles.button_wrapper}>
          {error
            ? (
              <AlertComponent
                message={t('common.resources.user.actions.create.failure', { context: 'already-exists' })}
                type='info'
              />
              )
            : (
              <ButtonComponent
                buttonText={t('common.resources.generic.actions.create.submit')}
                htmlType='submit'
                shape='round'
                colorType='secondary'
                loading={loading}
                disabled={isSubmitDisabled}
              />

              )}
        </div>
      </Form.Item>
    </Form>
  )
}

export default AddUserTeacherForm
